import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["container", "addbutton", "field", "template"]

    connect() {
    }

    get maxFields() {
        // Read from data attribute, fallback to 3
        const value = this.data.get("max-fields")
        return value ? parseInt(value, 10) : 3
    }

    get baseFormItemName() {
        const value = this.data.get("column")
        return value ? value : ""
    }

    updateAddButtonVisibility() {
        if (this.fieldTargets.length >= this.maxFields) {
            this.addbuttonTarget.classList.add("hidden")
        } else {
            this.addbuttonTarget.classList.remove("hidden")
        }
    }

    addField() {
        if (this.fieldTargets.length >= this.maxFields) {
            alert(`You can only add up to ${this.maxFields} fields.`)
            return
        }

        const content = this.templateTarget.content.cloneNode(true)
        this.containerTarget.appendChild(content)
        this.updateAddButtonVisibility();
    }

    removeField(event) {
        event.target.closest("[data-multi-row-text-target='field']").remove()
        this.updateAddButtonVisibility();
    }
  }